module.exports = __webpack_public_path__ + "img/doushayanwo.421995fc.jpg";